<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="代理商总览">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con"  :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">代理商</span>
                            <div class="input-condition">
                                <!--<el-autocomplete v-model="condition.name" :fetch-suggestions="querySearchAsync1" placeholder="请输入内容" valueKey="name"></el-autocomplete>-->
                                <factor-auto-complete v-model="condition.factor_id" clearable></factor-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 650px;">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="checkDate('month')" :class="condition.timeStamp === 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="checkDate('doubleMonth')" :class="condition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="请选择开始日期"
                                        end-placeholder="请选择结束日期"
                                        align="right"
                                        :picker-options="pickerOptions"
                                        @change="condition.timeStamp = ''"
                                        :maxTime="new Date()"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div class="customTab">
                    <div class="tabBox">
                        <div class="item_tab " >
                            <div class="item_value">{{total_400}}</div>
                            <div class="item_text">通话费用（元）</div>
                        </div>
                        <div class="item_tab" >
                            <div class="item_value">{{total_fee}}</div>
                            <div class="item_text">消费总额（元）</div>
                        </div>
                        <div class="item_tab" >
                            <div class="item_value">{{total_free}}</div>
                            <div class="item_text">赠送金额（元）</div>
                        </div>
                        <div class="item_tab" >
                            <div class="item_value">{{total_self_recharge}}</div>
                            <div class="item_text">自费金额（元）</div>
                        </div>
                    </div>
                </div>
                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="导出" placement="top">
                            <el-button icon="el-icon-download" @click="download"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->

                    <el-table-column  label="代理商名称" prop="name"></el-table-column>
                    <el-table-column  label="权限站点">
                        <template slot-scope="scope">
                            <p :title="scope.row.fullName">{{scope.row.sites_string}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column  label="通话费用（元）" prop="total_400"></el-table-column>
                    <el-table-column  label="消费总额（元）" prop="total_fee"></el-table-column>
                    <el-table-column  label="赠送金额（元）" prop="total_free"></el-table-column>
                    <el-table-column  label="自费金额（元）" prop="total_self_recharge"></el-table-column>
                    <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                    <el-table-column width="220px"  fixed="right">
                        <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                        <template slot="header" slot-scope="scope">
                            <span style="color: #409EFF">操作</span>
                        </template>
                        <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                        <template slot-scope="scope">
                                <el-button size="mini" @click="openRecharge(scope.$index, scope.row)" v-permission="'business.balance.recharge'"
                                           >充值记录</el-button>
                                <el-button size="mini" @click="openExpense(scope.$index, scope.row)" v-permission="'business.balance.expense'"
                                           >消费明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { parseTime } from '@/utils'
    import {  getFactorsList } from '@/service/user'
    import { getSite } from '@/service/site'
    import { factorBalanceList, factorBalanceTotal }  from '@/service/payment'
    import factorAutoComplete from '@/components/auto-complete/factor-auto-complete'
    export default {
        name: 'List',
        components: {
            factorAutoComplete
        },
        data () {
            return {
                condition: {
                    factor_id: '',
                    time: '',
                    timeStamp: 'month',
                    total : 0,
                    per_page : 10,
                    page : 1,
                },
                total_self_recharge:0,
                total_free:0,
                total_400:0,
                total_fee:0,
                isLoading: false, // 是否显示loading加载
                list: [],
                timeOptionRange:null,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                isShowMore: false
            }
        },
        mounted () {
            this.initData(1)
        },
        methods: {
            openExpense(index, row){
                this.$router.push('expense?id='+row.id+'&name='+row.name)
            },
            openRecharge(index, row){
                this.$router.push('recharge?id='+row.id+'&name='+row.name)
            },
            handleSearch() {
                this.condition.page = 1
                this.initData(1)
            },
            resetSearch() {
                this.condition = {
                    factor_id: '',
                    time: '',
                    timeStamp: 'month',
                    total : 0,
                    per_page : 10,
                    page : 1,
                }
                this.initData(1)
            },

            /** 初始化数据请求 */
            async initData (if_total) {
                let query = {
                    factor_id : this.condition.factor_id,
                    page : this.condition.page,
                    per_page : this.condition.per_page
                }
                if (this.condition.timeStamp.length > 0) {
                    query.time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                } else if(this.condition.time && this.condition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.condition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.condition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }

                this.isLoading = true
                // 模拟fetch请求数据....
                await factorBalanceList(query).then((data) => {
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        if (row.sites.length > 0) {
                            let names = [];
                            for (let j in row.sites) {
                                if (j > 2) {
                                    names.push('...')
                                    break
                                } else {
                                    names.push(row.sites[j].name)
                                }
                            }
                            row.sites_string = names.join(',')
                            row.fullName = row.sites.map(v => v.name).join(',')
                        } else {
                            row.sites_string = '--'
                        }
                        row.total_400 = row.total_400 / 100
                        row.total_free = row.total_free / 100
                        row.total_fee = row.total_fee / 100
                        row.total_self_recharge = row.total_self_recharge / 100

                    }
                    this.list = listData
                })
                if (if_total) {
                    await factorBalanceTotal(query).then((data) => {
                        this.total_400 = data.total_400 / 100
                        this.total_fee = data.total_fee  / 100
                        this.total_free = data.total_free  / 100
                        this.total_self_recharge = data.total_self_recharge  / 100
                    })
                }
                this.isLoading = false
            },
            checkDate (value) {
                this.condition = Object.assign({}, this.condition, {
                    timeStamp: value,
                    time: ''
                })
            },
            currentChange (index) {
                this.condition.page = index
                this.initData(0)
            },
            async download () {
                import('@/vendor/Export2Excel').then(async excel => {
                    const tHeader = ['代理商名称','关联站点','通话费用（元）','消费总额（元）','赠送金额（元）','自费金额（元）']
                    const filterVal = ['name','sites_string', 'total_400', 'total_fee', 'total_free','total_self_recharge']
                    let list = []
                    let query = {
                        factor_id : this.condition.factor_id,
                        export : 1,
                        page : 1,
                        per_page : 999
                    }
                    if (this.condition.timeStamp.length > 0) {
                        query.time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                    } else if(this.condition.time && this.condition.time.length > 0) {
                        query.start_time = Date.parse(new Date(this.condition.time[0]))/1000
                        query.end_time = Date.parse(new Date(this.condition.time[1]))/1000
                    } else {
                        this.$message({
                            message: '请选择时间段',
                            type: 'error',
                            duration: 3 * 1000
                        })
                        return
                    }
                    this.isLoading = true
                    // 模拟fetch请求数据....
                    await factorBalanceList(query).then((data) => {
                        let listData = data.data
                        for (let i in listData) {
                            let row = listData[i]
                            if (row.sites.length > 0) {
                                let names = [];
                                for (let j in row.sites) {
                                    names.push(row.sites[j].name)
                                }
                                row.sites_string = names.join(',')
                            } else {
                                row.sites_string = '--'
                            }
                            row.total_400 = row.total_400 / 100
                            row.total_free = row.total_free / 100
                            row.total_fee = row.total_fee / 100
                            row.total_self_recharge = row.total_self_recharge / 100

                        }
                        list = listData
                    })
                    const formatJson = (filterVal) => {
                        return list.map(v => filterVal.map(j => {
                            return v[j]
                        }))
                    }
                    let name = ''
                    if (this.condition.timeStamp.length > 0) {
                        let time_end = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
                        let time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                        let time_start = time_end - time_quantum * 3600 * 24 * 1000
                        name += parseTime(new Date(time_start), '{y}-{m}-{d}') + '至' + parseTime(new Date(time_end), '{y}-{m}-{d}')
                    } else {
                        name += parseTime( new Date(this.condition.time[0]), '{y}-{m}-{d}') + '至' + parseTime( new Date(this.condition.time[1]), '{y}-{m}-{d}')
                    }
                    name += '代理商总览'
                    const data = formatJson(filterVal)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: name
                    })
                    this.isLoading = false
                })
            },
        }
    }
</script>
